export default function findApproxMatches(searchSeq, targetSeq, maxMismatches, circular = false) {
  const matches = [];
  const lenA = searchSeq.length;
  const lenB = targetSeq.length;
  const searchSeqUpper = searchSeq.toUpperCase();
  const targetSeqUpper = targetSeq.toUpperCase();
  const targetSeqExtendedOriginal = circular ? targetSeq + targetSeq.slice(0, lenA - 1) : targetSeq;
  const targetSeqExtendedUpper = circular ? targetSeqUpper + targetSeqUpper.slice(0, lenA - 1) : targetSeqUpper;
  const limit = circular ? lenB : lenB - lenA + 1;
  for (let i = 0; i < limit; i++) {
    const windowUpper = targetSeqExtendedUpper.slice(i, i + lenA);
    let mismatchCount = 0;
    const mismatchPositions = [];
    for (let j = 0; j < lenA; j++) {
      if (searchSeqUpper[j] !== windowUpper[j]) {
        mismatchPositions.push(j);
        mismatchCount++;
        if (mismatchCount > maxMismatches) break;
      }
    }
    if (mismatchCount <= maxMismatches) {
      const windowOriginal = targetSeqExtendedOriginal.slice(i, i + lenA);
      matches.push({
        index: i,
        match: windowOriginal,
        mismatchPositions,
        numMismatches: mismatchPositions.length
        // Keep for backwards compatibility
      });
    }
  }
  return matches;
}
